import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

export default function CTA() {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-40 bg-[#050505] px-6 text-center">
      <div className="max-w-5xl mx-auto border-y border-white/10 py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-[#DFFF00]/5 blur-3xl pointer-events-none rounded-full" />
        
        <h2 className="text-5xl md:text-8xl font-black uppercase tracking-tighter text-white mb-12 italic leading-none">
          Ready to <br /><span className="text-[#DFFF00]">Scale or Die?</span>
        </h2>
        
        <p className="text-slate-400 text-xl max-w-2xl mx-auto mb-16 font-medium">
          We only accept 2 infrastructure partners per month. Secure your network slots before the next deployment cycle.
        </p>

        <button 
          onClick={scrollToContact}
          className="bg-white text-black px-16 py-8 font-black uppercase tracking-[0.2em] text-xl hover:bg-[#DFFF00] transition-all active:scale-95"
        >
          Request Protocol Briefing
        </button>
      </div>
    </section>
  );
}